<header class="site-header field-journal-header">
    <a class="brand-mark" routerLink="/home" (click)="closeMenu()" aria-label="GTX Inspections home">
        <img src="assets/images/logo.png" alt="GTX Inspections logo" />
        <span>
            <strong>GTX Inspections</strong>
            <small>Georgetown · TREC# 23635</small>
        </span>
    </a>

    <button class="mobile-menu-button" type="button" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen"
        aria-controls="primary-navigation" aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
    </button>

    <nav id="primary-navigation" class="primary-nav" [class.is-open]="menuOpen">
        <a routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeMenu()">Home</a>
        <a routerLink="/inspection" routerLinkActive="is-active" (click)="closeMenu()">Inspection</a>
        <a routerLink="/about" routerLinkActive="is-active" (click)="closeMenu()">About</a>
        <a routerLink="/contact" routerLinkActive="is-active" (click)="closeMenu()">Contact</a>
        <a routerLink="/resources" routerLinkActive="is-active" (click)="closeMenu()">Resources</a>
        <div class="field-journal-nav-note" aria-label="GTX local inspection note">
            <span>On-site notes</span>
            <strong>Roland inspects. Kari and Roland keep GTX personal.</strong>
        </div>
    </nav>

    <div class="header-actions" aria-label="Contact actions">
        <a class="phone-link" href="tel:512-848-1316">Call/Text</a>
        <a class="field-journal-schedule" routerLink="/contact" (click)="closeMenu()">Schedule</a>
    </div>
</header>
